import { appFormUtil } from 'modules/common';
import React, { useEffect } from 'react';

import {
  useRemovePlanMutation,
  RemovePlan_Input
} from 'generated/graphql';


export type IFormState = {
  id: string;
};

const initialState = {
  id: ''
};

export function useFormState(id: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'Id',
        type: 'text'
      }
    }
  });
  useEffect(() => {
    if (id && initialState.id === '') {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'id',
          value: id
        }
      });
    }
    return () => {};
  },
  [
    dispatch,
    id
  ]);

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useRemovePlan() {
  const [
    fnMutate,
    tuple
  ] = useRemovePlanMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: RemovePlan_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
